var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h3',[_vm._v(_vm._s(_vm.state)+" "),_c('b',[_vm._v(_vm._s(_vm.externalPersonEmail))]),_vm._v(" external person as a host to the event")]),_c('p',{staticClass:"text-red"},[_c('small',[_vm._v(_vm._s(_vm.errorMessage))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }